import { DateInput, NumberInput, TextInput } from '@core/components/Inputs';
import { SelectInput } from '@core/components/Select';
import { Grid, Tooltip } from '@material-ui/core';
import { PessoaJuridicaAutocomplete } from 'app/main/pessoa';
import React from 'react';

const VendedorDadosGeraisPessoaJuridica = ({
  id,
  name,
  values: { pessoaJuridica = {}, comissao, inscricaoMunicipal },
  errors = {},
  touched = {},
  onChange,
  onBlur,
  fetchPapel,
  possuiVinculo,
}) => {
  return (
    <>
      <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
        <PessoaJuridicaAutocomplete
          id={`${id}.cnpj`}
          name={`${name}.cnpj`}
          value={pessoaJuridica?.cnpj}
          error={errors?.pessoaJuridica?.cnpj}
          touched={touched?.pessoaJuridica?.cnpj}
          onBlur={onBlur}
          onChange={onChange}
          papel="vendedor"
          fetchPapel={fetchPapel}
          disabled={possuiVinculo && pessoaJuridica?.cnpj}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
        <TextInput
          id={`${id}.razaoSocial`}
          name={`${name}.razaoSocial`}
          onChange={onChange}
          onBlur={onBlur}
          value={pessoaJuridica.razaoSocial}
          error={errors?.pessoaJuridica?.razaoSocial}
          touched={touched?.pessoaJuridica?.razaoSocial}
          fullWidth
          variant="outlined"
          label="Razão social"
          maxLength={150}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
        <Tooltip placement="top-start" title="Percentual de comissão padrão do vendedor">
          <div>
            <NumberInput
              label="Comissão (%)"
              id="comissao"
              decimalScale={8}
              decimalSeparator=","
              allowNegative={false}
              isAllowed={(values) => {
                return !values.floatValue || values.floatValue <= 100;
              }}
              value={comissao}
              onChange={onChange}
              onBlur={onBlur}
            />
          </div>
        </Tooltip>
      </Grid>
      <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
        <DateInput
          fullWidth
          disableFuture
          id={`${id}.dataFundacao`}
          name={`${name}.dataFundacao`}
          label="Data da fundação"
          value={pessoaJuridica.dataFundacao}
          onChange={onChange}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        <SelectInput
          label="Indicador de inscrição estadual"
          id={`${id}.indicadorInscricaoEstadual`}
          name={`${name}.indicadorInscricaoEstadual`}
          onChange={onChange}
          value={pessoaJuridica.indicadorInscricaoEstadual}
          options={[
            { id: 'NAO_CONTRIBUINTE', title: 'Não contribuinte de ICMS' },
            { id: 'CONTRIBUINTE', title: 'Contribuinte de ICMS' },
            { id: 'CONTRIBUINTE_ISENTO', title: 'Contribuinte isento' },
          ]}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        <TextInput
          id={`${id}.inscricaoEstadual`}
          name={`${name}.inscricaoEstadual`}
          onChange={onChange}
          onBlur={onBlur}
          value={pessoaJuridica.inscricaoEstadual}
          error={errors?.pessoaJuridica?.inscricaoEstadual}
          touched={touched?.pessoaJuridica?.inscricaoEstadual}
          fullWidth
          variant="outlined"
          label="Inscrição estadual"
          replace={{ searchValue: /[^0-9]/gm, newValue: '' }}
          pattern={/^[0-9]*$/gm}
          maxLength={20}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        <TextInput
          id="pessoa.inscricaoMunicipal"
          name="pessoa.inscricaoMunicipal"
          onChange={onChange}
          onBlur={onBlur}
          value={inscricaoMunicipal}
          error={errors?.inscricaoMunicipal}
          touched={touched?.inscricaoMunicipal}
          fullWidth
          variant="outlined"
          label="Inscrição municipal"
          maxLength={20}
        />
      </Grid>
    </>
  );
};

export default VendedorDadosGeraisPessoaJuridica;
